import CloseIcon from "@mui/icons-material/Close";
import { Dialog, IconButton, Typography, Box, Paper } from "@mui/material";
import React from "react";



const HowToPlayModal = ({ onClose }) => {
  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ padding: '24px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            How To Play Crossover Trivia
          </Typography>
          <IconButton onClick={onClose} sx={{ padding: 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography variant="body1" sx={{ fontSize: { xs: '0.9rem', sm: '1rem' }, color: '#333' }}>
          Guess the prompt in the correct order for NFL or NBA trivia in 5
          tries. Click the player cards at the bottom to rank them based on the
          prompt like Top 5 in Rushing Touchdowns. Once you submit, the feedback
          for each guess is as follows:
        </Typography>

        <Box component="ul" sx={{ marginTop: '12px', color: '#333' }}>
          <li>
            <Typography component="span" sx={{ color: "#6aaa64", fontWeight: 600 }}>Green</Typography>
            : Emmitt Smith is in the ranking and in the correct spot.
          </li>
          <li>
            <Typography component="span" sx={{ color: "#c9b458", fontWeight: 600 }}>Yellow</Typography>
            : Adrian Peterson is in the ranking but in a different spot.
          </li>
          <li>
            <Typography component="span" sx={{ color: "#787c7e", fontWeight: 600 }}>Grey</Typography>
            : Franco Harris is not in the top 5 ranking.
          </li>
        </Box>

        <Box sx={{ marginTop: '20px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <Box sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#6aaa64',
            color: 'white',
            padding: { xs: '5px', sm: '8px' },
            fontWeight: 'bold',
            borderRadius: '4px',
            minWidth: { xs: '90px', sm: '120px' },
            textAlign: 'center'
          }}>
            Emmitt Smith
          </Box>
          <Box sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#c9b458',
            color: 'white',
            padding: { xs: '5px', sm: '8px' },
            fontWeight: 'bold',
            borderRadius: '4px',
            minWidth: { xs: '90px', sm: '120px' },
            textAlign: 'center'
          }}>
            Adrian Peterson
          </Box>
          <Box sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#787c7e',
            color: 'white',
            padding: { xs: '5px', sm: '8px' },
            fontWeight: 'bold',
            borderRadius: '4px',
            minWidth: { xs: '90px', sm: '120px' },
            textAlign: 'center'
          }}>
            Franco Harris
          </Box>
        </Box>

        <Paper sx={{
          background: '#00000015',
          padding: { xs: '0.5rem', sm: '1rem' },
          marginTop: '2rem',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <Typography sx={{
            fontFamily: "'font-prime', sans-serif",
            fontSize: { xs: '0.8rem', sm: '0.9rem' },
            margin: '0.5rem 0'
          }}>
            Crossover Trivia is only available for Amazon Prime members.
          </Typography>
          <Typography
            component="a"
            href="https://www.crossovergrid.com"
            sx={{
              fontFamily: "'font-prime', sans-serif",
              color: '#0073bb',
              marginTop: { xs: '0.5rem', sm: '1rem' },
              textDecoration: 'none',
              fontSize: '0.8rem',
              display: 'block',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Don't have Prime? Go back to the grids.
          </Typography>
        </Paper>
      </Box>
    </Dialog>
  );
};

export default HowToPlayModal;
